module.exports = __webpack_public_path__ + "static/media/Ecommerce.58dada80.png";